import React from 'react';
import { FuelAvatar } from '@frete.com/fuel-react';
import Notification from '../Notification';
import { TruckerAvatarPropsInterface } from './TruckerAvatarTypes';
import * as Styled from './TruckerAvatarStyles';

function TruckerAvatar({
  name,
  photo,
  notification = { isShow: false, total: 0 },
  hasOpacity = false,
  onClick,
}: TruckerAvatarPropsInterface) {
  if (!photo) {
    return (
      <Styled.WrapperAvatar hasOpacity={hasOpacity} onClick={onClick}>
        <FuelAvatar data-testid="avatar-icon" icon="user-area" slot="sign">
          <Notification {...notification} />
        </FuelAvatar>
      </Styled.WrapperAvatar>
    );
  }

  return (
    <Styled.WrapperAvatar hasOpacity={hasOpacity} onClick={onClick}>
      <FuelAvatar data-testid="avatar-img">
        <img slot="image" alt={`Avatar de ${name}`} src={photo} />
        <Notification {...notification} />
      </FuelAvatar>
    </Styled.WrapperAvatar>
  );
}

export default TruckerAvatar;
